import { ArticleHeading1, ArticleHeading2, ArticleParagraph1, ArticleParagraph2, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { SIDEBAR_CONTENT } from './constants';
import { clsx } from 'clsx';

interface IModalSidebarProps {
  step: number;
}

export const ModalSidebar: React.FC<IModalSidebarProps> = ({ step }) => {
  const device = useDeviceType();

  const isDesktop = device === 'desktop';

  const Heading = isDesktop ? ArticleHeading1 : ArticleHeading2;

  const Body = isDesktop ? ArticleParagraph1 : ArticleParagraph2;

  const { title, list } = SIDEBAR_CONTENT[step] ?? SIDEBAR_CONTENT[0];

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['image']} />
      <div className={styles['textblock']}>
        <Heading>{title}</Heading>
        <div className={styles['list']}>
          {list.map(({ text, image }, key) => (
            <div key={key} className={styles['item']}>
              <div className={clsx(styles['item-image'], styles[image])} />
              <Body>{text}</Body>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
